// Prompt 20 B1 — single source for the per-invoice price shown anywhere on the site.
export const PRICE_PER_INVOICE_USD = 0.25;
export const PRICE_LABEL = `$${PRICE_PER_INVOICE_USD.toFixed(2)}`;
